import {useInView} from "react-intersection-observer";

export const useAppInview = () => useInView({
    threshold: 0,
    triggerOnce:true
});